import { TagRule } from "models/events/TagRule"
import { Profile } from "models/profile/Profile"
import { makeRequest } from "./networkUtils"

export const getTagRules = (): Promise<TagRule[]> => {
    return makeRequest("tag-rules")
}

export const getTagRule = (id: string): Promise<TagRule> => {
    return makeRequest(`tag-rules/${id}`)
}

export const createTagRuleDO = (tagRule: TagRule): Promise<TagRule> => {
    return makeRequest("tag-rules", { method: "POST", body: tagRule })
}

export const saveTagRuleDO = (tagRule: TagRule): Promise<TagRule> => {
    const { id, ...rest } = tagRule;
    return makeRequest(`tag-rules/${id}`, { method: "PUT", body: rest })
}

export const deleteTagRuleDO = (tagRule: TagRule): Promise<void> => {
    return makeRequest(`tag-rules/${tagRule.id}`, { method: "DELETE" })
}

export const executeTagRuleDO = (tagRuleId: string): Promise<void> => {
    return makeRequest(`tag-rules/${tagRuleId}/execute`, { method: "POST" })
}

export const publishTagRules = (): Promise<void> => {
    return makeRequest("utils/publish", { method: "POST", body: { type: "tagRules" } })
}
